import React, { PureComponent } from 'react';
import {
  SEO,
  LevelHero,
  Inspiration,
  LevelChallenge,
  LevelObjective,
  LevelBenefits
} from 'components';
import styled, { css } from 'styled-components';
import axios from 'axios';
import { graphql } from 'gatsby';
import { Redirect } from '@reach/router';
import level1Icon from 'images/Shared/LevelIcons/WhiteStroke/level_01_icon.svg';

class Level1 extends PureComponent {
  state = {
    componentHasMounted: false,
    sendingForm: false,
    ['What is the key challenge?']: '',
    ["What's working?"]: '',
    ['What could we improve?']: '',
    ['What does success look like over the next 12 months?']: '',
    ['What are the KPI’s and how will we measure them?']: '',
    ['Who are the most valuable intended audiences for your campaign?']: '',
    ['Is there any other relevant information that you think may be useful?']: ''
  };

  componentDidMount() {
    this.setState({
      componentHasMounted: true
    });
  }

  handleInputChange = (e) => {
    this.setState({
      [e.target.name]: e.target.value
    });
  };

  encodeData = (data) => {
    const formData = new FormData();

    Object.keys(data).forEach((key) => formData.append(key, data[key]));

    return formData;
  };

  handleSubmit = (e) => {
    e.preventDefault();

    this.setState({
      sendingForm: true
    });

    const form = e.target;
    const { user, game, selectedLevel } = this.props;
    const { name, email } = user;

    axios({
      url: '/',
      method: 'POST',
      data: this.encodeData({
        'form-name': form.getAttribute('name'),
        game: game.title,
        name,
        email,
        ['What is the key challenge?']: this.state['What is the key challenge?'],
        ["What's working?"]: this.state["What's working?"],
        ['What could we improve?']: this.state['What could we improve?'],
        ['What does success look like over the next 12 months?']: this.state[
          'What does success look like over the next 12 months?'
        ],
        ['What are the KPI’s and how will we measure them?']: this.state[
          'What are the KPI’s and how will we measure them?'
        ],
        ['Who are the most valuable intended audiences for your campaign?']: this.state[
          'Who are the most valuable intended audiences for your campaign?'
        ],
        ['Is there any other relevant information that you think may be useful?']: this.state[
          'Is there any other relevant information that you think may be useful?'
        ]
      })
    }).then(() => {
      this.setState({
        sendingForm: false
      });
      this.props.toggleLevelCompleteModal(selectedLevel);
    });
  };

  render() {
    const { data, user, game, selectedLevel, viewportWidth } = this.props;
    const { levelData, manWritingOnPaper } = data;
    const {
      challenge,
      duration,
      levelPageSummary,
      levelVideoCode,
      title,
      objective,
      benefits,
      scoring
    } = levelData.childMarkdownRemark.frontmatter;
    let { tools } = levelData.childMarkdownRemark.frontmatter;
    const { componentHasMounted, sendingForm } = this.state;
    if (game && game.uniqueDocs) {
      game.uniqueDocs.forEach((uniqueDocs) => {
        if (uniqueDocs.level === selectedLevel) {
          tools.link = uniqueDocs.link;
        }
      });
    }
    if (game && game.uniqueDocs) {
      game.uniqueDocs.forEach((uniqueDocs) => {
        if (uniqueDocs.level === selectedLevel) {
          tools = {
            list: tools.list,
            link: uniqueDocs.link
          };
        }
      });
    }
    return user ? (
      <Wrapper>
        <SEO pageSpecificTitle="Level 1" pageSpecificDescription={levelPageSummary} />
        <LevelHero
          level={1}
          title={title}
          levelPageSummary={levelPageSummary}
          levelIcon={level1Icon}
          levelVideoCode={levelVideoCode}
        />
        <LevelObjective objective={objective} />
        <LevelChallenge challenge={challenge} duration={duration} tools={tools} />
        <SevenQuestions>
          <Form
            name="Level 1 Submission"
            method="POST"
            data-netlify="true"
            data-netlify-honeypot="bot-field"
            onSubmit={this.handleSubmit}>
            <Input type="hidden" name="form-name" value="Level 1 Submission" />
            <div hidden>
              <Label>
                Don’t fill this out:
                <Input name="bot-field" onChange={this.handleInputChange} />
              </Label>
            </div>
            <div style={{ position: 'absolute', opacity: 0, zIndex: -1 }}>
              <Label>
                Game
                <Input type="hidden" name="game" aria-label="game" />
              </Label>
            </div>
            <div style={{ position: 'absolute', opacity: 0, zIndex: -1 }}>
              <Label>
                Name
                <Input type="hidden" name="name" aria-label="name" />
              </Label>
            </div>
            <div style={{ position: 'absolute', opacity: 0, zIndex: -1 }}>
              <Label>
                Email
                <Input type="hidden" name="email" aria-label="email" />
              </Label>
            </div>
            <div>
              <Label>
                <div>
                  <QuestionNumber>1.</QuestionNumber>
                  <p>What is the key challenge?</p>
                </div>
                <TextArea
                  as="textarea"
                  placeholder="Your answer here"
                  name="What is the key challenge?"
                  cols="30"
                  rows="10"
                  aria-label="Your answer here"
                  onChange={this.handleInputChange}
                  value={this.state['What is the key challenge?']}
                  required
                />
              </Label>
            </div>
            <div>
              <Label>
                <div>
                  <QuestionNumber>2.</QuestionNumber>
                  <p>What&apos;s working?</p>
                </div>
                <TextArea
                  as="textarea"
                  placeholder="Your answer here"
                  name="What's working?"
                  cols="30"
                  rows="10"
                  aria-label="Your answer here"
                  onChange={this.handleInputChange}
                  value={this.state["What's working?"]}
                  required
                />
              </Label>
            </div>
            <div>
              <Label>
                <div>
                  <QuestionNumber>3.</QuestionNumber>
                  <p>What could we improve?</p>
                </div>
                <TextArea
                  as="textarea"
                  placeholder="Your answer here"
                  name="What could we improve?"
                  cols="30"
                  rows="10"
                  aria-label="Your answer here"
                  onChange={this.handleInputChange}
                  value={this.state['What could we improve?']}
                  required
                />
              </Label>
            </div>
            <div>
              <Label>
                <div>
                  <QuestionNumber>4.</QuestionNumber>
                  <p>What does success look like over the next 12 months?</p>
                </div>
                <TextArea
                  as="textarea"
                  placeholder="Your answer here"
                  name="What does success look like over the next 12 months?"
                  cols="30"
                  rows="10"
                  aria-label="Your answer here"
                  onChange={this.handleInputChange}
                  value={this.state['What does success look like over the next 12 months?']}
                  required
                />
              </Label>
            </div>
            <div>
              <Label>
                <div>
                  <QuestionNumber>5.</QuestionNumber>
                  <p>What are the KPI’s and how will we measure them?</p>
                </div>
                <TextArea
                  as="textarea"
                  placeholder="Your answer here"
                  name="What are the KPI’s and how will we measure them?"
                  cols="30"
                  rows="10"
                  aria-label="Your answer here"
                  onChange={this.handleInputChange}
                  value={this.state['What are the KPI’s and how will we measure them?']}
                  required
                />
              </Label>
            </div>
            <div>
              <Label>
                <div style={{ marginBottom: '0.292em' }}>
                  <QuestionNumber>6.</QuestionNumber>
                  <p>
                    Who are the most valuable intended audiences for your campaign?
                    <br />
                    <span>
                      (Be as specific as possible with customer types, influencers, patients,
                      patient groups)
                    </span>
                  </p>
                </div>
                <TextArea
                  as="textarea"
                  placeholder="Your answer here"
                  name="Who are the most valuable intended audiences for your campaign?"
                  cols="30"
                  rows="10"
                  aria-label="Your answer here"
                  onChange={this.handleInputChange}
                  value={
                    this.state['Who are the most valuable intended audiences for your campaign?']
                  }
                  required
                />
              </Label>
            </div>
            <div>
              <Label>
                <div>
                  <QuestionNumber>7.</QuestionNumber>
                  <p>Is there any other relevant information that you think may be useful?</p>
                </div>
                <TextArea
                  as="textarea"
                  placeholder="Your answer here"
                  name="Is there any other relevant information that you think may be useful?"
                  cols="30"
                  rows="10"
                  aria-label="Your answer here"
                  onChange={this.handleInputChange}
                  value={
                    this.state[
                      'Is there any other relevant information that you think may be useful?'
                    ]
                  }
                  required
                />
              </Label>
            </div>
            <SubmitButton type="submit" sendingForm={sendingForm}>
              {sendingForm ? 'Sending' : 'Submit'}
            </SubmitButton>
          </Form>
        </SevenQuestions>
        <InnerWrapper>
          <LevelBenefits
            benefits={benefits}
            level={selectedLevel}
            objective={objective}
            viewportWidth={viewportWidth}
            scoring={scoring}
          />
        </InnerWrapper>
        <Inspiration
          img={manWritingOnPaper}
          author="Stephen Covey, <em>7 Habits</em>"
          quote="Begin with the end in mind"
          quoteLargeFontSize="4rem"
          maxWidth="36.563em"
          viewportWidth={viewportWidth}
        />
      </Wrapper>
    ) : (
      componentHasMounted && <Redirect to="/" noThrow />
    );
  }
}

const QuestionNumber = styled.span`
  align-items: center;
  background-color: var(--cx-dark-green);
  border-radius: 0.125em;
  bottom: 0.02em;
  color: #fff;
  display: inline-flex;
  flex-shrink: 0;
  font-size: 1.5rem;
  height: 1.917em;
  justify-content: center;
  position: relative;
  width: 1.917em;
`;

const SevenQuestions = styled.div`
  background-color: rgba(239, 237, 228, 0.3);
  padding: 0 9.027777777777777% 2.625rem;
`;

const SubmitButton = styled.button`
  align-self: flex-end;
  background-color: #000;
  border: none;
  color: #fff;
  cursor: pointer;
  display: block;
  font-size: 1rem;
  font-weight: 700;
  height: 2.875em;
  outline-color: var(--cx-dark-green);
  text-transform: uppercase;
  width: 9.25em;

  ${({ sendingForm }) =>
    sendingForm &&
    css`
      &:after {
        content: ' .';
        margin-left: -3px;
        animation: dots 1s steps(5, end) infinite;
      }

      @keyframes dots {
        0%,
        20% {
          color: rgba(0, 0, 0, 0);
          text-shadow: 0.25em 0 0 rgba(0, 0, 0, 0), 0.5em 0 0 rgba(0, 0, 0, 0);
        }
        40% {
          color: #fff;
          text-shadow: 0.25em 0 0 rgba(0, 0, 0, 0), 0.5em 0 0 rgba(0, 0, 0, 0);
        }
        60% {
          text-shadow: 0.25em 0 0 #fff, 0.5em 0 0 rgba(0, 0, 0, 0);
        }
        80%,
        100% {
          text-shadow: 0.25em 0 0 #fff, 0.5em 0 0 #fff;
        }
      }
    `}
`;

const Label = styled.label`
  display: inline-block;
  font-size: 1.5rem;
  font-weight: 600;
  width: 100%;

  > div {
    align-items: flex-start;
    display: flex;

    > p {
      margin-left: 0.833em;
      position: relative;
      top: 0.375em;

      > span {
        font-weight: 400;
        position: relative;
        top: 0.167em;
      }
    }
  }
`;

const Input = styled.input`
  background-color: #fff;
  font-size: 1.25rem;
  height: 40px;
  outline-color: var(--cx-dark-green);
  padding: 0.5em;
  width: 100%;

  &::placeholder {
    font-size: 1.25rem;
    font-style: italic;
  }
`;

const TextArea = styled(Input)`
  border: 0.063rem solid var(--cx-dark-green);
  height: 15rem;
  margin: 0.95em auto 2.5em;
  width: 100%;
`;

const Form = styled.form`
  display: flex;
  flex-direction: column;
  margin: 0 auto;
  max-width: 73.75em;
  width: 100%;
`;

const Wrapper = styled.section``;

const InnerWrapper = styled.div`
  max-width: 90em;
  margin: 0 9.1%;
`;

export const Level1Query = graphql`
  {
    levelData: file(sourceInstanceName: { eq: "levelData" }, relativePath: { eq: "level_01.md" }) {
      childMarkdownRemark {
        frontmatter {
          title
          levelPageSummary
          levelVideoCode
          challenge {
            heading
            detail
          }
          objective
          benefits {
            forPlayers
            forTheCampaign
          }
          duration {
            time
            detail
          }
          scoring {
            challenge {
              points
              detail
            }
            teamGame {
              points
              detail
            }
          }
          tools {
            list
            link
          }
        }
      }
    }
    manWritingOnPaper: file(relativePath: { eq: "Shared/Inspiration/man_writing_on_paper.png" }) {
      name
      childImageSharp {
        fluid(maxWidth: 590, maxHeight: 620) {
          ...GatsbyImageSharpFluid_withWebp_tracedSVG
        }
      }
    }
  }
`;

export default Level1;
